module.exports = __webpack_public_path__ + "img/187440f.svg";